import AppLayout from "layouts/appLayout/AppLayout";
import { useRef } from "react";
import { AccordionProvider, Breadcrumb } from "stories";
import classes from "../proposedProject/ProposedProject.module.scss";

import { OpportunityQueryKey } from "configs/opportunity.config";
import { breadcrumbItems } from "pages/application/contstants";
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { OpportunityController } from "services/opportunity/controller";
import OpportunityCard from "../../index/elements/opportunityCard/OpportunityCard";
import { AssetBreakdown } from "./elements/assetBreakdown";
import { EquityBreakdown } from "./elements/equityBreakdown";
import FinancialAnalysis from "./elements/financialAnalysis/FinancialAnalysis";
import { SourcesAndUsesOfFunds } from "./elements/sourcesAndUsesOfFunds";

const opportunityController = OpportunityController();

const FinancialBreakdown = () => {
  const params = useParams();
  const equityBreakdownRef = useRef();
  const assetBreakdownRef = useRef();
  const sourcesAndUsesOfFundsRef = useRef();
  const financialAnalysisRef = useRef();
  const queryKey = [OpportunityQueryKey, { id: params.id }];
  const { isLoading, data: opportunity } = useQuery({
    queryKey,
    queryFn: opportunityController.getById.bind(null, params.id),
  });

  const saveCallBack = (refs) => {
    refs.forEach((ref) => {
      ref.current.refetch();
    });
  };

  return (
    <AppLayout
      title={"Complete full details about the opportunity"}
      hideSidebar
      backButton
    >
      <Helmet>
        <title>Financial Breakdown | Fundever</title>
      </Helmet>
      <Breadcrumb items={breadcrumbItems} selectedId={2} />
      <div className={classes["main-wrapper"]}>
        <div className={"mb-3"}>
          <OpportunityCard
            readOnly
            loading={isLoading}
            data={{ id: params.id, ...opportunity }}
          />
          <AccordionProvider scrollOnChange>
            <EquityBreakdown
              ref={equityBreakdownRef}
              onSave={saveCallBack.bind(null, [
                assetBreakdownRef,
                sourcesAndUsesOfFundsRef,
                financialAnalysisRef,
              ])}
            />
            <AssetBreakdown
              ref={assetBreakdownRef}
              onSave={saveCallBack.bind(null, [
                sourcesAndUsesOfFundsRef,
                financialAnalysisRef,
              ])}
            />
            <SourcesAndUsesOfFunds
              ref={sourcesAndUsesOfFundsRef}
              onSave={saveCallBack.bind(null, [financialAnalysisRef])}
            />
            <FinancialAnalysis ref={financialAnalysisRef} />
          </AccordionProvider>
          <Row className={"mt-4"}>
            <Col xs={9} />
            <Col>{/* <Button outline label={"Publish Now"} /> */}</Col>
          </Row>
        </div>
      </div>
    </AppLayout>
  );
};

export default FinancialBreakdown;
